import classnames from "classnames";
import { useMemo } from "react";
import { render, Root } from "./grid";
import styles from "./table.module.scss";

export function Table({
    grid,
    loading,
    onRowClick,
    className,
    children,
    ...props
}) {
    const hasFooters = useMemo(
        () => false, // TODO - check grid options for footers
        [grid]
    );

    return (
        <Root grid={grid}>
            <table {...props} className={classnames(className, styles.table)}>
                {children}
                <thead>
                    {grid.getHeaderGroups().map(({ id, headers }) => (
                        <tr key={id} data-id={id}>
                            {headers.map((header) => (
                                <th
                                    key={header.id}
                                    data-id={header.id}
                                    data-align={header.column.headerAlign}
                                >
                                    {header.isPlaceholder
                                        ? null
                                        : render.header(header)}
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody>
                    {loading
                        ? grid
                              .getHeaderGroups()
                              .filter((_, i) => i == 0)
                              .map(({ id, headers }) => (
                                  <tr key={id} data-id={id}>
                                      {headers.map((header) => (
                                          <td
                                              key={header.id}
                                              data-id={header.id}
                                              data-align={header.column.align}
                                              className={styles.loading}
                                              data-loading="true"
                                          >
                                              <LoadingCell />
                                          </td>
                                      ))}
                                  </tr>
                              ))
                        : grid.getRowModel().rows.map((row) => (
                              <tr
                                  key={row.id}
                                  data-id={row.id}
                                  onClick={(event) => onRowClick?.(event, row)}
                              >
                                  {row.getVisibleCells().map((cell) => (
                                      <td
                                          key={cell.id}
                                          data-id={cell.column.id}
                                          data-align={cell.column.align}
                                      >
                                          {render.cell(cell)}
                                      </td>
                                  ))}
                              </tr>
                          ))}
                </tbody>
                {hasFooters ? (
                    <tfoot>
                        {grid.getFooterGroups().map(({ id, headers }) => (
                            <tr key={id} data-id={id}>
                                {headers.map((footer) => (
                                    <th
                                        key={footer.id}
                                        data-id={footer.id}
                                        data-align={footer.column.footerAlign}
                                    >
                                        {footer.isPlaceholder
                                            ? null
                                            : render.footer(footer)}
                                    </th>
                                ))}
                            </tr>
                        ))}
                    </tfoot>
                ) : null}
            </table>
        </Root>
    );
}
Table.displayName = "Grid.Table";

function LoadingCell() {
    return <span>...</span>;
}
